<template>
  <section class="black-friday-hero">
    <div
      :class="[
        'black-friday-hero__content',
        isBlackFridayPage && 'black-friday-hero__content--mt-10',
      ]"
    >
      <div class="black-friday-hero__logo">
        <h1 class="black-friday-hero__maintitle">BLACK FRIDAY</h1>
        <h2 class="black-friday-hero__subtitle">DEALS ARE BACK</h2>
      </div>
      <div class="black-friday-hero__title">Choose your own training adventure.</div>
      <div class="black-friday-hero__intro">
        Dive into Black Friday deals to discover the perfect training plan for individual learners!
      </div>
      <div v-if="!isBlackFridayPage" class="black-friday-hero__learn-more">
        <router-link :to="{ name: 'black-friday' }" class="btn btn--primary btn--full-mobile">
          Shop savings
        </router-link>
      </div>
    </div>
    <div class="black-friday-hero__icon">
      <div class="black-friday-hero__logo-wrapper">
        <BLLogo class="black-friday-hero__icon__logo" />
        <BLCircleLogo class="black-friday-hero__icon__circle" />
      </div>
    </div>
  </section>
</template>

<script>
import BLLogo from '@/assets/images/hero-section/black-friday/bl-logo.svg'
import BLCircleLogo from '@/assets/images/hero-section/black-friday/bl-circle-logo.svg'
import { routesRules } from '@/helpers/mixins'

export default {
  name: 'BlackFridayHeroSection',
  mixins: [routesRules],
  components: {
    BLLogo,
    BLCircleLogo,
  },
}
</script>

<style lang="scss" scoped>
.black-friday-hero {
  width: 100%;
  max-width: 1120px;
  padding: 50px 20px 20px 20px;
  color: var(--white);
  font-family: var(--font-regular);
  display: flex;
  position: relative;
  flex-direction: column-reverse;
  @include mobile {
    margin: 85px auto 60px auto;
    padding: 0 20px;
    flex-direction: row;
  }
  @include tablet {
    margin: 85px auto 105px auto;
  }
  &__maintitle {
    color: var(--white, #fff);
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: rem(50px);
    font-style: normal;
    font-weight: 900;
    margin: 0;
    @include mobile {
      font-size: rem(48px);
      font-style: normal;
      font-weight: 900;
      line-height: rem(61px);
    }
    @include tablet {
      margin: 0 0 10px 0;
      font-size: rem(72px);
      font-style: normal;
      font-weight: 900;
    }
  }
  &__subtitle {
    color: var(--brilliant-rose);
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: rem(40px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(36px);
    margin: 0;
    @include mobile {
      font-size: rem(48px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(50px);
    }
    @include tablet {
      font-size: rem(54px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(50px);
    }
  }

  &__title {
    font-family: var(--font-bold);
    font-size: rem(17px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(24px);
    margin-top: 20px;
    @include tablet-ipad-air-and-mini-portrait {
      font-size: rem(24px);
      line-height: rem(32px);
      margin-top: 0;
    }
    @include mobile {
      font-size: rem(20px);
      line-height: rem(26px);
      margin-top: 0;
    }
    @include tablet {
      font-size: rem(24px);
      line-height: rem(32px);
      margin-top: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;
    flex-flow: column;
    z-index: 1;
    &--mt-10 {
      margin-top: 10%;
      @include mobile {
        margin: 0;
        padding: 0;
      }
    }
    @include tablet-ipad-air-and-mini-portrait {
      font-size: rem(24px);
      line-height: rem(32px);
      gap: 0;
    }
    @include mobile {
      gap: 10px;
      max-width: 571px;
    }
    @include tablet {
      font-size: rem(24px);
      line-height: rem(32px);
      gap: 0;
    }
    @include desktop {
      width: 95%;
      max-width: 568px;
    }
  }

  &__intro {
    font-size: rem(17px);
    font-style: normal;
    font-weight: 450;
    line-height: 24px;
    margin-bottom: 20px;
    @include tablet-ipad-air-and-mini-portrait {
      color: var(--light-blue-gray);
      font-size: rem(24px);
      line-height: rem(32px);
      width: 100%;
    }
    @include mobile {
      color: var(--light-blue-gray);
      font-size: rem(20px);
      line-height: rem(26px);
      max-width: 475px;
    }
    @include tablet {
      color: var(--light-blue-gray);
      font-size: rem(24px);
      line-height: rem(32px);
    }
  }
  &__logo-wrapper {
    position: relative;
    width: 288px;
    height: 250px;
    margin: 0 auto;
    @include tablet {
      height: 441px;
      width: 581px;
    }
  }
  &__icon {
    position: relative;
    margin-bottom: 30px;
    @include mobile {
      margin-bottom: 0;
    }
    @include tablet {
      position: absolute;
      margin-top: -85px;
      right: -55px;
    }
    &__logo {
      position: absolute;
      z-index: 2;
      width: 100%;
      height: 100%;
      @include tablet {
        height: 441px;
        width: 581px;
      }
    }
    &__circle {
      position: absolute;
      left: 50%;
      z-index: 0;
      top: 0;
      transform: translateX(-50%) rotate(0deg);
      animation: spin 50s linear infinite;
      width: 70%;
      height: 100%;
      @include tablet {
        width: 414px;
        height: 413px;
      }
    }
  }
}
@keyframes spin {
  100% {
    transform: translateX(-50%) rotate(360deg);
  }
}
</style>
